module.exports = __webpack_public_path__ + "img/about-company2.c636adcb.png";